/**
 * Configuration utility for accessing environment variables
 */

// OpenRouter API key for AI design suggestions
export const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY;

// API Base URL
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

// Helper function to check if required config is available
export const isConfigValid = () => {
  const missingVars = [];

  if (!OPENROUTER_API_KEY) {
    missingVars.push("REACT_APP_OPENROUTER_API_KEY");
  }

  return {
    valid: missingVars.length === 0,
    missingVars,
  };
};
